$(document).ready(function(){

  if($('.slideshow__controls .slider-counter__link:first-child').hasClass('slider-counter__link--active')){
    $('.slideshow__controls .slider-button.slider-button--prev').attr('disabled',true);
  }

  $(document).on('click','.slideshow__controls  .slider-button',function(){

    $('.slideshow__controls .slider-button.slider-button--next').attr('disabled',false);

    setTimeout(function(){
      if($('.slideshow__controls .slider-counter__link:last-child').hasClass('slider-counter__link--active')){
        $('.slideshow__controls .slider-button.slider-button--next').attr('disabled',true);
      }
    },500)
      
  })

  $(document).on('click','.slideshow__controls  .slider-button',function(){

    $('.slideshow__controls .slider-button.slider-button--prev').attr('disabled',false);

    setTimeout(function(){
      if($('.slideshow__controls .slider-counter__link:first-child').hasClass('slider-counter__link--active')){
        $('.slideshow__controls .slider-button.slider-button--prev').attr('disabled',true);
      }
    },1000)
      
  })

  $('.coll-tabs-label label').click(function(){
    $('.coll-tabs-main-collection').removeClass('active');
    var id = $(this).attr('data-attr');
    $('.coll-tabs-main-collection').each(function(){
        var idd = $(this).attr('id');
        if(id == idd){
            $(this).addClass('active');
            $('html, body').animate({
                scrollTop: $('.coll-tabs-main-collection.active').offset().top - 150
              }, 2000);
        }
    })
  })
  
  $('fieldset.js.product-form__input legend.form__label .size-chart-cls').click(function(){
    $('.product-popup-modal__opener button').trigger('click');
  })

    var maxHeight = 0;
    $(".blog .card__heading.h2").each(function(){
     if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
    });
    $(".blog .card__heading.h2").height(maxHeight);
  
})


